/*
 * @description: 用户信息
 * @Author: Jay
 * @Date: 2023-12-19 16:34:18
 * @LastEditors: Jay
 * @LastEditTime: 2025-09-09 17:12:41
 */

const state = {
  // 存储token 没登录默认false
  Authorization: sessionStorage.getItem('Authorization') ? sessionStorage.getItem('Authorization') : '',
  //身份 0则是商户 1是代理
  rankType: sessionStorage.getItem('saveRankType') ? sessionStorage.getItem('saveRankType') : '',
  //全局 隐藏中间位
  showHide: true,
}

const mutations = {
  LOGIN(state, provider) {
    // 存储token
    state.Authorization = provider;
    sessionStorage.setItem('Authorization', provider);
    // console.log('存储token', state.Authorization)
  },
  LOGOUT(state) {
    state.Authorization = '';
    // 删除指定key本地存储的值
    sessionStorage.removeItem('Authorization')
    // 删除 本地存储菜单 id
    sessionStorage.removeItem("menuId")
  },
  //身份 0则是商户 1是代理
  SETRANK(state, provider) {
    state.rankType = provider;
    sessionStorage.setItem('saveRankType', provider);
    // console.log('身份', state.rankType)
  }
}

const actions = {

}



export default {
  namespaced: true,
  state,
  mutations,
  actions
}
